export const generateAddOpinionLink = (url: string): string => `${url?.replace('opinie', 'ocen')}?utm_source=skapiec&#zawartosc`;
